<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Motivo Cancelamento">
          <listar-MotivoCancelamento />
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListarMotivoCancelamento from '@/components/patio/ListarMotivoCancelamento'
export default {
  name: 'MotivoCancelamento',
  data() {
    return {
      page: {
        title: 'Gerenciamento de Motivo de Cancelamento',
      },
      breadcrumbs: [
        {
          text: 'Administrativo',
          disabled: true,
          to: '/administrativo',
        },
        {
          text: 'Motivo Cancelamento',
          disabled: true,
        },
      ],
    }
  },
  components: {
    ListarMotivoCancelamento,
  },
}
</script>

<style></style>
